import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './ConfirmDialog.module.css';

function ConfirmDialog({ message, confirmLabel, cancelLabel, danger, onConfirm, onCancel }) {
  const { t } = useTranslation();

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onCancel();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onCancel]);

  return (
    <div className={styles.overlay} role="alertdialog" aria-modal="true" aria-label={message} onClick={onCancel}>
      <div className={styles.dialog} onClick={(e) => e.stopPropagation()}>
        <p className={styles.message}>{message}</p>
        <div className={styles.actions}>
          <button type="button" className={styles.cancelButton} onClick={onCancel}>
            {cancelLabel || t('confirmDialog.cancel')}
          </button>
          <button
            type="button"
            className={`${styles.confirmButton} ${danger ? styles.confirmButtonDanger : ''}`}
            onClick={onConfirm}
            autoFocus
          >
            {confirmLabel || t('confirmDialog.confirm')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmDialog;
